import { Component } from "react";
import { withRouter } from "react-router-dom";

class RouteChangeWatcher extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.props.onRouteChange();
        }
    }
    render() { return null; }
}

export default withRouter(RouteChangeWatcher);
